<template>
<div v-if="pagination.totalItem > pagination.itemForPage" v-bind:class="[classstyle]">
    <ul class="pagination justify-content-center">

        <li class="page-item" v-if="totalPage > 3" v-bind:class="[pagination.page == 0 ? 'disabled' : '' ]">
            <a class="page-link" href="javascript:;" @click="changePage(0)">
                <i class="fas fa-angle-double-left"></i>
            </a>
        </li>

        <li class="page-item" v-bind:class="[pagination.page == 0 ? 'disabled' : '' ]">
            <a class="page-link" href="javascript:;" @click="changePage(pagination.page-1)" aria-label="Pagina precedente">
                <span>
                    <i class="fas fa-arrow-left" aria-hidden="true"></i><span class="sr-only">Pagina precedente</span>
                </span>

            </a>
        </li>

        <li class="page-item" v-if="pagination.page >= 2">

            <a class="page-link" @click="changePage(pagination.page-2)" href="javascript:;">
                {{pagination.page-1}}
            </a>

        </li>
        <li class="page-item" @click="changePage(pagination.page-1)" v-if="pagination.page >= 1">

            <a class="page-link" href="javascript:;">
                {{pagination.page}}
            </a>

        </li>

        <li class="page-item active">

            <a class="page-link" href="javascript:;">
                {{pagination.page+1}}
            </a>

        </li>

        <li class="page-item" @click="changePage(pagination.page+1)" v-if="pagination.page+2 <=totalPage">

            <a class="page-link" href="javascript:;">
                {{pagination.page+2}}
            </a>

        </li>

        <li class="page-item" @click="changePage(pagination.page+2)" v-if="pagination.page+3 <=totalPage">

            <a class="page-link" href="javascript:;">
                {{pagination.page+3}}
            </a>

        </li>



        <li class="page-item" v-bind:class="[pagination.page+1 >= totalPage ? 'disabled' : '' ]"> 
            <a class="page-link" href="javascript:;" @click="changePage(pagination.page+1)"  aria-label="Pagina successiva">
                <span>
                    <i class="fas fa-arrow-right" aria-hidden="true"></i><span class="sr-only">Pagina successiva</span>
                </span>
            </a>
        </li>

        <li class="page-item" v-if="totalPage > 3" v-bind:class="[pagination.page+1 >= totalPage ? 'disabled' : '' ]"> 
            <a class="page-link" href="javascript:;" @click="changePage(totalPage-1)">
                <i class="fas fa-angle-double-right"></i>
            </a>
        </li>
    </ul>
</div>

</template>

<script>
    export default {
        props: {
            classstyle: { default: function () { return ''; }},
            pagination: { default: function () { return {}; } },
        },
        data: function(){
            return {
            }
        },
        computed: {
            totalPage() {
                if (!this.pagination) return 0;
                if (!this.pagination.totalItem || !this.pagination.itemForPage) return 0;
                return Math.ceil(this.pagination.totalItem/this.pagination.itemForPage);
            },
            pages() {
                let pages = [];
                for (let index = 1; index <= this.totalPage; index++) {
                    pages.push(index);
                }
                return pages;
            }
        },
        watch: { 
           pagination: function(newValue, oldValue) {
               this.pagination = newValue;
               if (this.pagination.page > this.totalPage) this.changePage(0);
            }
        },
        mounted(){
        },
        methods: {
            changePage(curPage) {
                if (curPage == this.pagination.page) return;
                this.pagination.page = curPage;
                this.$emit("on-page-change", {
                        pagination:this.pagination
                });
            },
            
        }
    }
</script>
<style lang="scss" scoped>


</style>